import "./components/SavedListCreateItem.es.js";
import "./components/SavedListEdit.es.js";
import "./components/SavedListItem.es.js";
import "./components/SavedListItemEdit.es.js";
import { jsx as e } from "react/jsx-runtime";
import { forwardRef as s } from "react";
import { useMultiStyleConfig as m } from "@chakra-ui/react";
import { SavedListComponent as n } from "./SavedList.component.es.js";
import { useSavedList as d, SavedListProvider as l, SavedListStylesProvider as v } from "./SavedList.context.es.js";
const h = s(
  (t, o) => {
    const i = "context" in t ? t.context : d(t), r = m("SavedList");
    return /* @__PURE__ */ e(l, { value: i, children: /* @__PURE__ */ e(v, { value: r, children: /* @__PURE__ */ e(n, { ref: o, styles: t.styles }) }) });
  }
);
export {
  h as SavedList
};
//# sourceMappingURL=SavedList.container.es.js.map
